import 'CssFolder/user.scss'
import { messageComponent } from '../../../components/message/message.component';
import ViewBase from '../../view-base.view';
import CampaignDetailView from './campaign-detail.view';
import CampaignRegisterView from './campaign-register/campaign-register.view';
import CampaignSearchView from './campaign-search.view'


export default function CampaignView() {
  ViewBase.call(this);

  const SCREEN_CAMPAIGN_SEARCH = 1;
  const SCREEN_CAMPAIGN_REGISTER = 2;

  const SCREENS = {
    [SCREEN_CAMPAIGN_SEARCH]: CampaignSearchView,
    [SCREEN_CAMPAIGN_REGISTER]: CampaignRegisterView,
  };

  const changeScreen = (screenId) => {
    this.state.currentScreen = SCREENS[screenId];
    this.state.currentScreenNumber = screenId;
  };

  const campaignViewState = {
    filterParams: {},
    campaignList: [],
    listDirty: true,
    updateObject(newObj) {
      let objToEdit = this.campaignList.find((element) => element.campaignId === newObj.campaignId);
      Object.assign(objToEdit, newObj);
    },
    saveState(campaignList, filterParams) {
      this.campaignList = _.cloneDeep(campaignList);
      this.filterParams = _.cloneDeep(filterParams);
      this.listDirty = false;
    },
    clearState() {
      this.filterParams = {};
      this.campaignList = [],
      this.listDirty = true;
    }
  };

  let isMsgOpen = false;
  let showMsg = "";
  let msgTitle = "";
  let isListPage = true;
  let selectedCampaignName = "";
  let selectedCampaignId = "";
  let isNew = false;
  let showTabs = true;

  let tabButton = (txt, screenId, icon = undefined) => {
    let activeClass = screenId === this.state.currentScreenNumber ? "btn-primary" : "btn-outline-primary";
    return m("a.btn[role=tablist]",
      {
        class: activeClass,
        onclick: () => {
          changeScreen(screenId);
        }
      },
      icon !== undefined && icon,
      txt
    )
  }

  return {
    oninit: (vnode) => {
      this.initState(vnode.state);
      changeScreen(SCREEN_CAMPAIGN_SEARCH);
    },
    view: (vnode) => {
      return [
        isListPage &&
        m('.row',
          m(".col-md-12",
            showTabs &&
            m(".d-flex.gap-3",
              tabButton(this.getText("LT00000001", "Search"), SCREEN_CAMPAIGN_SEARCH, m('i.bi.bi-search')),
              tabButton(this.getText("LT00000017", "Register"), SCREEN_CAMPAIGN_REGISTER, m('i.bi.bi-plus-lg')),
            ),
            showTabs && m('hr.my-3', { style: 'background-color: var(--is-link-blue);' }),
            m("div",
              m(this.state.currentScreen, {
                campaignViewState: campaignViewState,
                campaignId: selectedCampaignId,
                campaignName: selectedCampaignName,
                onSaved: (result) => {
                  showTabs = true;
                  if (result.transResult && result.transResult.length > 0) {
                    isMsgOpen = true;
                    showMsg = result.transResult[0].message;
                    msgTitle = result.transResult[0].transStatus;
                  }
                  changeScreen(SCREEN_CAMPAIGN_SEARCH);
                  setTimeout(() => {
                    changeScreen(SCREEN_CAMPAIGN_REGISTER);
                  }, 100);
                },
                onOpenQuestionList: (campaignId) => {
                  isNew = true;
                  selectedCampaignId = campaignId;
                  isListPage = false;
                },
                onViewCampaign: (campaignId, campaignName) => {
                  selectedCampaignId = campaignId;
                  selectedCampaignName = campaignName;
                  isListPage = false;
                },
                onEditClick: (id, name) => {
                  showTabs = false;
                  selectedCampaignId = id;
                  selectedCampaignName = name;
                  changeScreen(SCREEN_CAMPAIGN_REGISTER);
                },
                onGoBackList: () => {
                  showTabs = true;
                  selectedCampaignId = "";
                  selectedCampaignName = "";
                  changeScreen(SCREEN_CAMPAIGN_SEARCH);
                }
              }),

            ),
          )
        ),
        !isListPage &&
        m(CampaignDetailView, {
          isNew: isNew, 
          campaignId: selectedCampaignId, 
          campaignName: selectedCampaignName, 
          campaignViewState: campaignViewState, 
          onSaveComplete: () => {
            isListPage = true;
            showTabs = true;
            selectedCampaignId = "";
            changeScreen(SCREEN_CAMPAIGN_SEARCH);
          },
          onGoBackList: () => {
            isListPage = true;
            showTabs = true;
            selectedCampaignId = "";
            selectedCampaignName = "";
            changeScreen(SCREEN_CAMPAIGN_SEARCH);
          }
        }),
        m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: () => { isMsgOpen = false; } }),
        this.getBaseViews()
      ]
    }
  }
}
